import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";
import CookieIcon from '@mui/icons-material/Cookie';
import { useCookie } from "../context/CookieProvider";
import PropTypes from "prop-types";

const CookieConsentDialog = ({ open, onClose, onAccept, onDecline }) => {
  const { setCookie } = useCookie();

  const handleAccept = () => {
    setCookie("google_analytics", "accepted", 365, "/");
    if (onAccept) onAccept();
    onClose();
  };

  const handleDecline = () => {
    setCookie("google_analytics", "declined", 365, "/");
    if (onDecline) onDecline();
    onClose();
  };

  return (
    <Dialog open={open} onClose={(event, reason) => {
      if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
        onClose();
      }
    }}
      disableEscapeKeyDown sx={{ textAlign: "center", margin: "auto", width: "100%" }}>
      <CookieIcon sx={{ width: "100px", height: "100px", marginLeft: "41%", mt: 3, color: '#1D5271' }} />
      <DialogTitle sx={{ fontWeight: "600" }}>Cookie Consent</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ color: "#000" }}>
          This website has optional cookies which will be applied to your computer with your consent.
          These Cookies are performance and analytical cookies designed to track and measure your engagement with our website, any data captured by these cookies are promptly anonymised.
          For more information, please visit our cookies policy by <a href="/CookiePolicy" target="_blank" style={{ color: '#005969', textDecoration: "underline" }}>clicking here.</a>
          <br /><br />
          Do you accept these cookies operating on your device?
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
        <Button variant="contained" onClick={handleAccept} sx={{ backgroundColor: '#123456', borderRadius: '0px', marginRight: "15px" }}>
          Accept
        </Button>
        <Button onClick={handleDecline} sx={{ color: '#123456', borderColor: '#123456', borderRadius: '0px' }} variant="outlined">
          Decline
        </Button>
      </DialogActions>
    </Dialog>
  );
};

CookieConsentDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onAccept: PropTypes.func,
  onDecline: PropTypes.func,
};

export default CookieConsentDialog;
